import React, { useState } from "react";
import {
  FaUserCheck,
  FaTicketAlt,
  FaChevronDown,
  FaBars,
  FaTimes,
  FaCog,
  FaCalendarCheck,
  FaUsers,
  FaMoneyCheckAlt,
  FaFileInvoiceDollar,
  FaCar,
  FaCalendarTimes,
  FaCalendarDay,
  FaClock,
  FaUsersCog,
  FaBullhorn,
  // FaWpforms,
  FaHistory,
  FaKey,
  FaUserClock,
  FaFileInvoice,
  // FaPiggyBank,
  FaBalanceScale,
  // FaNetworkWired,
  FaUserTie,
  // FaFileSignature,
  // FaBriefcase,
  // FaHeadset
} from "react-icons/fa";
import { PiNetworkFill } from "react-icons/pi";
import { RiCashFill } from "react-icons/ri";
import { MdRuleFolder, MdSpaceDashboard } from "react-icons/md";
// import { IoDocumentText } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import { IconType } from "react-icons/lib";
import ageLogo from "../../assets/AGE-logo.png";

interface SubMenuItem {
  label: string;
  path: string;
  visibleTo?: string[];
  icon: IconType;
}

interface MenuItem {
  icon: IconType;
  label: string;
  path: string;
  subItems?: SubMenuItem[];
  visibleTo?: string[];
}

const menuItems: MenuItem[] = [
  { icon: MdSpaceDashboard, label: "Dashboard", path: "/dashboard" },
  {
    icon: PiNetworkFill,
    label: "Organization",
    path: "/organization",
    visibleTo: ["HR", "manager", "SuperAdmin", "test", "Finance"],
    subItems: [
      {
        label: "Attendance Data",
        path: "/organization/attendance-management",
        visibleTo: ["manager", "SuperAdmin", "HR"],
        icon: FaCalendarCheck,
      },
      {
        label: "Employees",
        path: "/organization/employee-management",
        visibleTo: ["HR", "SuperAdmin"],
        icon: FaUsers,
      },
      {
        label: "Payroll Management",
        path: "/organization/payroll-management",
        visibleTo: ["HR", "SuperAdmin"],
        icon: FaMoneyCheckAlt,
      },
      {
        label: "Payroll Finance",
        path: "/organization/payroll-finance",
        visibleTo: ["SuperAdmin", "Finance"],
        icon: FaFileInvoiceDollar,
      },
      {
        label: "Vehicle Finance",
        path: "/organization/vehicle-finance",
        visibleTo: ["SuperAdmin", "Finance"],
        icon: FaCar,
      },
      {
        label: "Leaves",
        path: "/organization/leave-management",
        visibleTo: ["HR", "manager", "SuperAdmin"],
        icon: FaCalendarTimes,
      },
      {
        label: "Tickets",
        path: "/organization/ticket-management",
        visibleTo: ["HR", "manager", "SuperAdmin"],
        icon: FaTicketAlt,
      },
      {
        label: "Holidays",
        path: "/organization/holiday-management",
        visibleTo: ["HR", "SuperAdmin"],
        icon: FaCalendarDay,
      },
      {
        label: "Shifts",
        path: "/organization/user-shift-management",
        visibleTo: ["HR", "manager", "SuperAdmin"],
        icon: FaClock,
      },
      {
        label: "Teams",
        path: "/organization/team-management",
        visibleTo: ["HR", "manager", "SuperAdmin"],
        icon: FaUsersCog,
      },
      {
        label: "Notices",
        path: "/organization/notice-management",
        visibleTo: ["HR", "SuperAdmin"],
        icon: FaBullhorn,
      },
      // {
      //   label: "Forms",
      //   path: "/organization/forms-management",
      //   visibleTo: ["SuperAdmin"],
      //   icon: FaWpforms,
      // },
      {
        label: "Vehicles",
        path: "/organization/vehicle-management",
        visibleTo: ["HR", "SuperAdmin"],
        icon: FaCar,
      },
      // {
      //   label: "Activity Logs",
      //   path: "/organization/activity-logs",
      //   visibleTo: ["HR", "SuperAdmin"],
      //   icon: FaHistory,
      // },
      {
        label: "Passwords",
        path: "/admin/password-manager",
        visibleTo: ["SuperAdmin"],
        icon: FaKey,
      },
      {
        label: "Attendance Manager",
        path: "/organization/attendance-manager",
        visibleTo: ["test"],
        icon: FaUserClock,
      },
    ],
  },
  {
    icon: FaUserCheck,
    label: "My Attendance",
    path: "/attendance",
    subItems: [
      { label: "View History", path: "/attendance/view", icon: FaHistory },
      { label: "Leave Balances", path: "/payroll/available-leaves", icon: FaBalanceScale },
      {
        label: "Holidays",
        path: "/attendance/view-holidays",
        icon: FaCalendarDay,
      },
    ],
  },
  {
    icon: RiCashFill,
    label: "My Payroll",
    path: "/payroll",
    subItems: [
      { label: "Payslips", path: "/payroll/view", icon: FaFileInvoice },
      // { label: "Provident Fund", path: "/payroll/provident-fund", icon: FaPiggyBank },
    ],
  },
  {
    icon: FaTicketAlt,
    label: "Support Tickets",
    path: "/tickets",
    subItems: [
      { label: "Attendance Support", path: "/tickets/attendance", icon: FaCalendarCheck },
      // { label: "Network Support", path: "/tickets/network", icon: FaNetworkWired },
      { label: "HR Support", path: "/tickets/hr", icon: FaUserTie },
      // { label: "Admin Support", path: "/tickets/admin", icon: FaHeadset },
    ],
  },
  // {
  //   icon: IoDocumentText,
  //   label: "Documents",
  //   path: "/letters",
  //   subItems: [
  //     { label: "Employment Letter", path: "/letters/employee-letter", icon: FaFileSignature },
  //     { label: "Experience Letter", path: "/letters/experience-letter", icon: FaBriefcase },
  //   ],
  // },
  { icon: MdRuleFolder, label: "Policies", path: "/policies" },
  { icon: FaCog, label: "Settings", path: "/settings" },
];

interface SidebarProps {
  role: string;
}

const Sidebar: React.FC<SidebarProps> = ({ role }) => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({
    Organization: true,
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleMenu = (label: string) => {
    setOpenMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const isMenuActive = (item: MenuItem): boolean => {
    if (item.subItems) {
      return item.subItems.some((sub) => sub.path === location.pathname);
    }
    return location.pathname === item.path;
  };

  const filteredMenuItems = ["Finance", "SuperAdmin"].includes(role)
    ? menuItems.filter((item) => ["Dashboard", "Organization"].includes(item.label))
    : menuItems.filter(
      (item) => !item.visibleTo || item.visibleTo.includes(role),
    );

  return (
    <>
      <button
        onClick={() => setIsSidebarOpen(true)}
        className="md:hidden fixed top-4 left-4 z-40 p-2.5 text-white bg-gunmetal-800/90 backdrop-blur-md border border-white/10 rounded-xl shadow-2xl hover:bg-gunmetal-700 hover:scale-105 transition-all duration-300"
      >
        <FaBars size={20} />
      </button>

      {/* Overlay */}
      <div
        onClick={() => setIsSidebarOpen(false)}
        className={`fixed inset-0 bg-carbon-black-950/70 backdrop-blur-md z-40 md:hidden transition-all duration-300 ${isSidebarOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
      ></div>

      <aside
        className={`fixed z-50 inset-y-0 left-0 transform ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } md:translate-x-0 md:relative md:flex md:flex-col w-[250px] h-screen transition-all duration-500 ease-[cubic-bezier(0.2,0.8,0.2,1)] shadow-[4px_0_40px_rgba(0,0,0,0.8)] bg-[#03060D] border-r border-[#1e2433] overflow-hidden backdrop-blur-3xl`}
      >
        {/* Futuristic Ambient Glows */}
        <div className="absolute top-[-5%] left-[-10%] w-64 h-64 bg-indigo-600/10 blur-[100px] pointer-events-none rounded-full"></div>
        <div className="absolute bottom-1/4 right-[-20%] w-72 h-72 bg-emerald-600/5 blur-[100px] pointer-events-none rounded-full"></div>
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.02] mix-blend-overlay pointer-events-none"></div>

        {/* Logo Area */}
        <div className="relative flex justify-between items-center px-5 py-7 z-10 border-b border-[#1e2433]/60 bg-[#03060D]/50 backdrop-blur-md">
          <div className="flex items-center gap-3">
            <div className="relative group/logo">
              <div className="absolute -inset-1.5 bg-gradient-to-r from-indigo-500/40 via-purple-500/20 to-emerald-500/40 rounded-xl blur-lg group-hover/logo:opacity-100 opacity-60 transition-all duration-700 animate-pulse"></div>
              <div className="relative flex items-center justify-center w-9 h-9 bg-gradient-to-tr from-[#0F172A] to-[#1E293B] rounded-lg ring-1 ring-white/10 shadow-[0_0_20px_rgba(0,0,0,0.5)] group-hover/logo:scale-[1.05] transition-transform duration-500">
                <img
                  src={ageLogo}
                  alt="Alvi Global Enterprises"
                  className="w-6 h-6 object-contain drop-shadow-[0_0_8px_rgba(255,255,255,0.6)]"
                />
              </div>
            </div>
            <div className="flex flex-col justify-center">
              <span className="text-xl font-display font-black tracking-tight text-transparent bg-clip-text bg-gradient-to-br from-white via-slate-200 to-slate-500 drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
                AGE<span className="text-indigo-400 font-bold"> HRM</span>
              </span>
              <div className="flex items-center gap-1.5 overflow-hidden">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,1)] animate-ping"></span>
                <span className="text-[8px] text-slate-400 font-bold uppercase tracking-[0.3em] font-mono">
                  Enterprise
                </span>
              </div>
            </div>
          </div>
          <button
            onClick={() => setIsSidebarOpen(false)}
            className="md:hidden p-1.5 text-slate-400 hover:text-white hover:bg-white/10 rounded-lg transition-all duration-300"
          >
            <FaTimes size={16} />
          </button>
        </div>

        {/* Scrollable Menu */}
        <nav className="relative flex-1 overflow-y-auto py-4 px-3 space-y-1.5 z-10 [&::-webkit-scrollbar]:w-0.5 [&::-webkit-scrollbar-thumb]:bg-indigo-500/30 [&::-webkit-scrollbar-track]:bg-transparent hover:[&::-webkit-scrollbar-thumb]:bg-indigo-500/50 transition-colors">
          <div className="px-2 mb-3 mt-1 flex items-center justify-between">
            <span className="text-[9px] font-bold uppercase tracking-[0.2em] text-slate-500 font-mono">Main Nav</span>
            <div className="h-[1px] w-8 bg-gradient-to-r from-slate-600/50 to-transparent"></div>
          </div>

          {filteredMenuItems.map((item, index) => {
            const Icon = item.icon;
            const isActive = isMenuActive(item);

            return (
              <div key={index} className="flex flex-col group/menu">
                {item.subItems ? (
                  <div>
                    <button
                      onClick={() => toggleMenu(item.label)}
                      className={`relative w-full flex items-center justify-between px-2.5 py-2.5 rounded-xl transition-all duration-400 ${isActive
                        ? "bg-gradient-to-r from-indigo-500/15 via-purple-500/5 to-transparent text-white ring-1 ring-indigo-500/30 shadow-[inset_2px_0_0_rgba(99,102,241,1)]"
                        : "text-slate-400 hover:bg-[#0B101E] hover:text-white hover:ring-1 hover:ring-white/5"
                        }`}
                    >
                      <div className="flex items-center gap-3 relative z-10">
                        <div className={`p-1.5 rounded-lg transition-all duration-300 ${isActive ? "bg-indigo-500/20 shadow-[0_0_15px_rgba(99,102,241,0.3)] ring-1 ring-indigo-500/40" : "bg-transparent group-hover/menu:bg-white/5"}`}>
                          <Icon
                            size={14}
                            className={`${isActive ? "text-indigo-300 drop-shadow-[0_0_8px_rgba(99,102,241,0.8)]" : "text-slate-500 group-hover/menu:text-slate-300"} transition-all duration-300`}
                          />
                        </div>
                        <span className={`font-semibold text-xs tracking-wide ${isActive ? "text-white" : "text-slate-400 group-hover/menu:text-slate-200"}`}>
                          {item.label}
                        </span>
                      </div>

                      <div
                        className={`relative z-10 flex items-center justify-center transition-all duration-300 ${openMenus[item.label] ? "text-indigo-400 rotate-180 scale-110" : "text-slate-600 group-hover/menu:text-slate-400"
                          }`}
                      >
                        <FaChevronDown size={10} />
                      </div>
                    </button>

                    {/* Submenu */}
                    <div
                      className={`grid transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] ${openMenus[item.label] ? "grid-rows-[1fr] opacity-100 mt-1.5" : "grid-rows-[0fr] opacity-0"
                        }`}
                    >
                      <div className="overflow-hidden">
                        <div className="relative pl-3 ml-4 py-1 space-y-0.5 border-l border-white/5 before:absolute before:inset-y-0 before:left-0 before:w-[1px] before:bg-gradient-to-b before:from-indigo-500/0 before:via-indigo-500/40 before:to-indigo-500/0 before:opacity-0 before:transition-opacity hover:before:opacity-100">
                          {item.subItems
                            .filter((subItem) => !subItem.visibleTo || subItem.visibleTo.includes(role))
                            .map((subItem, subIndex) => {
                              const isSubActive = location.pathname === subItem.path;
                              const SubIcon = subItem.icon;

                              return (
                                <Link
                                  to={subItem.path}
                                  key={subIndex}
                                  className={`relative flex items-center gap-3 px-3 py-2 rounded-lg text-[11px] font-semibold transition-all duration-300 group/sub ${isSubActive
                                    ? "bg-[#0B1224] text-white shadow-[0_4px_12px_rgba(0,0,0,0.3)] ring-1 ring-indigo-500/20"
                                    : "text-slate-500 hover:text-slate-200 hover:bg-white/5 hover:translate-x-1"
                                    }`}
                                >
                                  {isSubActive ? (
                                    <div className="absolute -left-[13px] top-1/2 -translate-y-1/2 w-1.5 h-1.5 bg-indigo-400 rounded-full shadow-[0_0_8px_rgba(129,140,248,1)] z-20"></div>
                                  ) : (
                                    <div className="absolute -left-[12px] top-1/2 -translate-y-1/2 w-1 h-1 bg-slate-700 rounded-full transition-all duration-300 group-hover/sub:bg-slate-400 group-hover/sub:scale-150 z-20"></div>
                                  )}

                                  {SubIcon && (
                                    <SubIcon
                                      size={12}
                                      className={`relative z-10 transition-all duration-300 ${isSubActive ? "text-indigo-400 drop-shadow-[0_0_5px_rgba(129,140,248,0.6)]" : "text-slate-600 group-hover/sub:text-slate-400"
                                        }`}
                                    />
                                  )}
                                  <span className="relative z-10 tracking-wide">{subItem.label}</span>
                                </Link>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Link
                    to={item.path}
                    className={`relative flex items-center gap-3 px-2.5 py-2.5 rounded-xl transition-all duration-400 overflow-hidden group/link outline-none ${isActive
                      ? "bg-gradient-to-r from-indigo-500/15 via-purple-500/5 to-transparent text-white ring-1 ring-indigo-500/30 shadow-[inset_2px_0_0_rgba(99,102,241,1)]"
                      : "text-slate-400 hover:bg-[#0B101E] hover:text-white hover:ring-1 hover:ring-white/5"
                      }`}
                  >
                    {isActive && (
                      <div className="absolute top-0 right-0 w-16 h-16 bg-indigo-500/20 blur-2xl rounded-full mix-blend-screen pointer-events-none"></div>
                    )}

                    <div className={`relative z-10 p-1.5 rounded-lg transition-all duration-300 ${isActive ? "bg-indigo-500/20 shadow-[0_0_15px_rgba(99,102,241,0.3)] ring-1 ring-indigo-500/40" : "bg-transparent group-hover/link:bg-white/5"}`}>
                      <Icon
                        size={14}
                        className={`relative z-10 ${isActive ? "text-indigo-300 drop-shadow-[0_0_8px_rgba(99,102,241,0.8)]" : "text-slate-500 group-hover/link:text-slate-300"} transition-all duration-300`}
                      />
                    </div>
                    <span className={`relative z-10 font-semibold text-xs tracking-wide ${isActive ? "text-white" : "text-slate-400 group-hover/link:text-slate-200"}`}>
                      {item.label}
                    </span>
                  </Link>
                )}
              </div>
            );
          })}
        </nav>

        {/* Footer Ultra Premium Island */}
        <div className="relative p-4 mx-3 mb-4 mt-2 rounded-[20px] bg-gradient-to-br from-[#0F172A]/80 to-[#02040A]/90 border border-[#1e2433] shadow-[0_8px_32px_rgba(0,0,0,0.6)] z-10 overflow-hidden group/footer hover:border-indigo-500/30 transition-all duration-500">
          <div className="absolute inset-0 bg-gradient-to-tr from-indigo-500/5 to-transparent opacity-0 group-hover/footer:opacity-100 transition-opacity duration-700 pointer-events-none"></div>
          <div className="absolute -top-10 -right-10 w-24 h-24 bg-indigo-500/10 blur-[30px] rounded-full pointer-events-none group-hover/footer:bg-indigo-500/20 transition-colors duration-700"></div>
          {/*           
          <div className="relative z-10 flex items-center gap-3 mb-4">
            <div className="relative">
              <div className="absolute inset-0 bg-indigo-500/20 rounded-full blur-md group-hover/footer:bg-indigo-500/40 transition-colors duration-500"></div>
              <div className="relative flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-b from-[#1E293B] to-[#0F172A] ring-1 ring-white/10 p-1.5">
                <img
                  src={ageLogo}
                  alt="Alvi Global Enterprises"
                  className="w-full h-full object-contain mb-[1px]"
                />
              </div>
            </div>
            <div className="flex flex-col">
              <span className="text-[11px] font-bold text-slate-200 tracking-wide group-hover/footer:text-white transition-colors">
                Alvi Global Ent.
              </span>
              <div className="mt-0.5 bg-indigo-500/10 text-indigo-300 text-[8px] font-mono font-bold uppercase tracking-widest px-1.5 py-0.5 rounded-[4px] border border-indigo-500/20 w-max shadow-[0_0_10px_rgba(99,102,241,0.1)]">
                PRO 2.5.0
              </div>
            </div>
          </div> */}

          <div className="relative z-10 space-y-3">
            <div>
              <span className="text-[8px] text-slate-500 uppercase tracking-[0.3em] mb-1 block font-mono font-bold">
                Developed By
              </span>
              <span className="text-[13px] font-display font-black bg-clip-text text-transparent bg-gradient-to-r from-slate-200 to-slate-400 drop-shadow-sm group-hover/footer:from-indigo-200 group-hover/footer:to-white transition-all duration-500">
                Amjad Ali
              </span>
            </div>
            <a
              href="https://amjadali.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex flex-row items-center justify-between w-full text-[10px] text-slate-400 hover:text-indigo-200 transition-all duration-400 group/link px-3 py-2 rounded-xl bg-[#0B101E] hover:bg-gradient-to-r hover:from-indigo-500/10 hover:to-transparent border border-white/5 hover:border-indigo-500/20 shadow-[inset_0_1px_rgba(255,255,255,0.02)]"
            >
              <span className="font-bold tracking-wide uppercase font-mono text-[9px]">Visit Site</span>
              <div className="bg-[#1E293B] p-1 rounded-lg group-hover/link:bg-indigo-500/20 group-hover/link:text-indigo-300 transition-all duration-300 ring-1 ring-white/5 group-hover/link:ring-indigo-500/40">
                <svg
                  className="w-2.5 h-2.5 transform group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5 transition-transform"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </div>
            </a>
            <div className="pt-3 border-t border-white/5 mt-1">
              <p className="text-[8px] text-slate-600 uppercase tracking-[0.2em] font-bold font-mono text-center">
                © {new Date().getFullYear()} AMJAD ALI
              </p>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
